import { render, staticRenderFns } from "./OrderNewControls.vue?vue&type=template&id=c92a12f2&scoped=true&"
import script from "./OrderNewControls.vue?vue&type=script&lang=ts&"
export * from "./OrderNewControls.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a12f2",
  null
  
)

export default component.exports